import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    detailsContainer: {
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        padding: `${theme.spacing(4)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
        height: "100%",
        display: "flex",
        flexDirection: "column" as const,
        "@media (min-width: 1300px)": {
            padding: `${theme.spacing(6)}`,
            paddingBottom: 0,
            height: "98%",
        },
    },
    detailsTitle: {
        color: theme.palette.text.secondary,
        fontSize: "24px !important",
        textAlign: "left",
    },
    paper: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column" as const,
        boxShadow: "unset !important",
    },
    tableContainer: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto" as const,
    },
    tableRow: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.table.main,
        },
    },
    tableCell: {
        padding: `${theme.spacing(2.5)} !important`,
        "@media (min-width: 1300px)": {
            padding: `${theme.spacing(4)} !important`,
        },
    },
    highlightedTableRow: {
        backgroundColor: theme.palette.error.lighter,
    },
}));
